export default __webpack_public_path__ + "static/media/ipad_15.1b2b8c03.png";